import axiosClient from "./axiosClient";

export const getCompanyTheme = (params) => {
  return axiosClient.get("/company/companyTheme", params);
};

export const getCompanyInfo = (params) => {
  return axiosClient.get("/company/companyInfo", params);
};
